import "./PaymentMethod.css";

import { useEffect, useState } from "react";

interface PaymentMethodProps {
  name: string;
  images?: any;
  link: string;
  setLink?: (link: any) => void;
  isQR?: boolean;
  setScanToPayOpened?: (opened: boolean) => void;
}

const PaymentMethod = ({
  name,
  images,
  link,
  setLink,
  isQR,
  setScanToPayOpened,
}: PaymentMethodProps) => {
  const onLinkClicked = () => {
    if (!isQR) {
      setLink && setLink({ name: name, link: link });
    } else {
      setScanToPayOpened && setScanToPayOpened(true);
    }
  };
  return (
    <div className="payment-method" onClick={() => onLinkClicked()}>
      <div className="payment-method-header">
        <p className="payment-title">
          {name.replace(/\_/g, " ").toUpperCase() === "CAPITEC EFT"
            ? "CAPITEC PAY"
            : name.replace(/\_/g, " ").toUpperCase()}
        </p>
        <div className="payment-method-thumbnail-container">
          {images?.map((image: any, index: number) => (
            <img
              className="payment-method-thumbnail"
              style={{
                maxWidth: name === "CAPITEC_EFT" ? 60 : 60,
                maxHeight: name === "CAPITEC_EFT" ? 20 : 20,
              }}
              key={index}
              src={image}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
